import './KnownIssuesPage.css'
import { useNavigate } from 'react-router-dom'
import { Row, Col } from 'react-bootstrap'
import { DcsPermissions, ICustomColumn, IPageProps } from 'types'
import { AddButton, PageHeader } from 'components'
import { V1ApiIntegrationsClient } from 'core/http-common'
import { useState } from 'react'
import toast from 'core/toast'
import SAGrid, { GridGetDataProps, GetDataResponse } from 'components/Grid/SAGrid'
import { GridDetailRowProps, GridRowClickEvent, GridRowProps } from '@progress/kendo-react-grid'
import { anyPermissionsRedirect } from 'core/helpers'
import KnownIssueDetails from './KnownIssueDetails'
import { KnownIssueDto } from 'generated/v1/v1IntegrationsApi'

export interface IDropDownStringValue {
    id: string,
    text: string
}

const KnownIssuesPage = ({ title }: IPageProps) => {

    const navigate = useNavigate()

    const [loaded, setLoaded] = useState(false)

    const issueColumns: ICustomColumn[] = [
        { field: 'knownIssueId', title: 'Known Issue ID' },
        { field: 'title', title: 'Title' },
        { field: 'reportedDate', title: 'Reported Date', format: '{0:g}', filterType: 'date' },
        { field: 'closeDate', title: 'Closed Date', format: '{0:g}', filterType: 'date' },
        { field: 'status', title: 'Status' },
        { field: 'system', title: 'System' },
        { field: 'lastModifiedDate', title: 'Last Modified Date', format: '{0:g}', filterType: 'date' },
    ]

    const rowClicked = (e: GridRowClickEvent) => {
        anyPermissionsRedirect([DcsPermissions.EditDevelopment], `/integrations/known-issues/edit/${e.dataItem.knownIssueId}`, navigate)
    }

    const fetch = async (props: GridGetDataProps): Promise<GetDataResponse> => {
        try {
            const result = await V1ApiIntegrationsClient.getKnownIssues(
                props.search,
                props.sortBy,
                props.sortAscending,
                props.paging && props.paging.currentPage ? props.paging.currentPage : 1,
                props.paging ? props.paging.take : 50,
            )
            setLoaded(true)
            return {
                data: result.data,
                total: result.totalItems ? result.totalItems : 0
            }
        }
        catch (e) {
            toast.responseErrors(e)
            return {
                data: [],
                total: 0
            }

        }
    }
    const DetailComponent = (props: GridDetailRowProps) => (<KnownIssueDetails knownIssue={props.dataItem as KnownIssueDto} />)

    return (
        <div id='KnownIssuesPage'>
            <PageHeader title={title}>
                <AddButton className='btn-lg btn-primary btnWidth mb-2 mb-md-0' onClick={() => navigate('/integrations/known-issues/add')}>
                    Add Known Issue
                </AddButton>
            </PageHeader>

            <Row>
                <Col>
                    <SAGrid
                        features={
                            {
                                sortable: true,
                                pageable: true,
                                reorderColumns: true,
                                simpleSearch: true
                            }
                        }
                        columns={issueColumns}
                        defaultSort={[{ field: 'lastModifiedDate', dir: 'desc' }]}
                        getData={fetch}
                        onRowClick={rowClicked}
                        detail={DetailComponent}
                    />
                </Col>
            </Row>
        </div>
    )
}
export default KnownIssuesPage